import AzureBlobDocsFeature from '../../features/docs/azure-blob-feature';

export default function AzureBlobDocsPage() {
  return <AzureBlobDocsFeature />;
}
